export const RouteStaticModel = {
    id: "",
    name: "",
    description: "",
    panel: "",
    download_type: "",
    waste_type: "",
    type_route: "",
    checkpoints: [],
    idx: "",
    geojson: {},
    duration: 0
}
